import React from 'react';
import { Button, Checkbox, FormControlLabel, IconButton } from '@mui/material';
import { X } from 'lucide-react';

const SideSheet = ({
  overviewCards = [],
  draftVisibleOverviewCards = {},
  onClose,
  onSave,
  onToggleCard,
  onToggleSelectAll
}) => {
  const selectedCardCount = overviewCards.filter((card) => draftVisibleOverviewCards[card.id]).length;
  const allCardsSelected = overviewCards.length > 0 && selectedCardCount === overviewCards.length;
  const someCardsSelected = selectedCardCount > 0 && selectedCardCount < overviewCards.length;

  return (
    <div className="analytics-customize-overlay" role="presentation" onMouseDown={onClose}>
      <aside
        className="analytics-customize-sheet"
        aria-label="Customize analytics overview"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="analytics-customize-sheet__header">
          <div>
            <h2 className="analytics-customize-sheet__title">Customize Overview</h2>
            <p className="analytics-customize-sheet__subtitle">Choose which cards to show.</p>
          </div>
          <IconButton aria-label="Close customize panel" onClick={onClose}>
            <X size={20} />
          </IconButton>
        </div>

        <div className="analytics-customize-sheet__list">
          <FormControlLabel
            className="analytics-customize-sheet__option analytics-customize-sheet__option--select-all"
            control={
              <Checkbox
                checked={allCardsSelected}
                indeterminate={someCardsSelected}
                onChange={(event) => onToggleSelectAll(event.target.checked)}
              />
            }
            label="Select all"
          />

          {overviewCards.map((card) => (
            <FormControlLabel
              key={card.id}
              className="analytics-customize-sheet__option"
              control={
                <Checkbox
                  checked={draftVisibleOverviewCards[card.id]}
                  onChange={() => onToggleCard(card.id)}
                />
              }
              label={card.title}
            />
          ))}
        </div>

        <div className="analytics-customize-sheet__actions">
          <Button variant="text" className="analytics-customize-sheet__cancel" onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" className="analytics-customize-sheet__save" onClick={onSave}>
            Save
          </Button>
        </div>
      </aside>
    </div>
  );
};

export default SideSheet;
